export default {
    byPerson(id) {
        return this.transformer.many(
            this.try(
                this.baseQuery().where('personId', id).get()
            )
        )
    }
}
